module.exports = __webpack_public_path__ + "static/img/solution4.7d1b22e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/solution4.jpg
// module id = hdTl
// module chunks = 9